//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Annotations.js";
import "../no/TaggedObject.js";
import "../Drawings/Drawings.SelectDraftingView.js";
import "../no/SelectDisplayableObject.js";
import "../Annotations/Annotations.PlaneBuilder.js";
import "../no/ugmath.js";
import "../no/SelectObject.js";
let d=[[[0,"Anchor",1,0],[1,"AnnotationView",0,"Drawings.SelectDraftingView",0],[1,"Origin",0,"SelectDisplayableObject",0],[0,"OriginPoint",1,0],[1,"Plane",0,"Annotations.PlaneBuilder",0]],[[[],"GetAssociativeOrigin",{R_:{assoc_origin:''}},0,0],[["assoc_origin"],"SetAssociativeOrigin",{},1,0],[["infer_relative_to_geometry"],"SetInferRelativeToGeometry",{},1,0],[["inferFromLeader"],"SetInferRelativeToGeometryFromLeader",{},1,0],[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.Annotations.OriginBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Annotations.OriginBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Annotations.OriginBuilder.AlignmentPosition = Object.freeze({
    "TopLeft" : "TopLeft", "TopCenter" : "TopCenter", "TopRight" : "TopRight", "MidLeft" : "MidLeft", "MidCenter" : "MidCenter", "MidRight" : "MidRight", "BottomLeft" : "BottomLeft", "BottomCenter" : "BottomCenter", "BottomRight" : "BottomRight"});

export default SPLM;